var AdaptiveImage = require("../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-spirometry.ec1d477a.png","uri@2x": __webpack_public_path__ + "icon-spirometry.12907a0a.png","uri@3x": __webpack_public_path__ + "icon-spirometry.9ba3fa41.png",
    width: 20,
    height: 20
});